module.exports = __webpack_public_path__ + "img/w8-b3.34b13140.jpg";